import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { IAllFlagsProvider } from './all-flags-provider.interface';
import { AllFlags, FeatureFlag } from './flags.types';
import { IAllFlagsProviderToken } from './launch-darkly-flags-data.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsFacade {
  allFlags$: Observable<AllFlags>;

  constructor(@Inject(IAllFlagsProviderToken) allFlagsProvider: IAllFlagsProvider) {
    this.allFlags$ = allFlagsProvider.allFlags$;
  }

  /**
   * for when determining whether a flag is boolean enabled/disabled
   */
  asObservable(feature: FeatureFlag): Observable<boolean> {
    return this.allFlags$.pipe(
      map((f) => {
        return f[feature] === true;
      })
    );
  }

  /**
   * For when Launch Darkly is intended to send values (number, strings, etc) to client
   */
  featureValueAsObservable<Type extends string | number | boolean>(feature: FeatureFlag): Observable<Type> {
    return this.allFlags$.pipe(
      map((f) => {
        return f[feature] as Type;
      })
    );
  }

  asPromise(feature: FeatureFlag) {
    return this.asObservable(feature).pipe(first()).toPromise();
  }
}
